import CopilotPreview from 'ai-addon-copilot-preview/components/CopilotPreview/CopilotPreview';
import CopilotProvider from 'copilot-toolkit/CopilotProvider';
import { useCallback } from 'react';
import { View } from 'foundations-components/transitional/components/View';
// @ts-expect-error file not typed
import { setupCsat } from 'wootric-nps/csat/csat-setup';
import I18n from 'I18n';
import { useGetTranscriptionStatus } from '../hooks/useGetTranscriptionStatus';
import { getDisabledMessagingFromTranscription } from '../utils/getDisabledMessagingFromTranscription';
import { CALL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { jsx as _jsx } from "react/jsx-runtime";
const AutogenerateCopilotCallSummary = ({
  usageTracker,
  callId,
  usageTrackerAppLocationKey
}) => {
  const {
    isDisabled,
    disabledReason
  } = useGetTranscriptionStatus(callId);
  const {
    disabledSubtitle,
    disabledDescription
  } = getDisabledMessagingFromTranscription(disabledReason);
  const onAskAQuestionClick = useCallback(() => {
    setupCsat('CALL_SUMMARY');
  }, []);
  return /*#__PURE__*/_jsx(CopilotProvider, {
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(CopilotPreview, {
        overrideDisabled: {
          isDisabled,
          disabledSubtitle,
          disabledDescription
        },
        useActionButton: false,
        appName: "recording-review-ui",
        copilotAction: {
          intent: 'object_summary',
          context: {
            summary_location: 'COPILOT_PREVIEW'
          },
          objectId: `${callId}`,
          objectTypeId: CALL_TYPE_ID,
          objectTypeLabel: 'call',
          label: `with id ${callId}`
        },
        autoGenerate: true,
        copilotActionButtonText: "Summarize this call",
        previewTitle: I18n.text('call-summary.notesTitle'),
        usageTracker: usageTracker,
        previewKey: `0-4fff:${callId}`,
        previewSource: "CALLING_SUMMARY",
        usageTrackerAppLocationKey: usageTrackerAppLocationKey || 'Call-Summary:Copilot-Call-Summary',
        onAskAQuestionClick: onAskAQuestionClick
      })
    })
  });
};
export default AutogenerateCopilotCallSummary;